import { IAccessToken, IAccessTokenCreateResult } from '@common/interfaces/accessToken'
import { combineReducers } from 'redux'
import { loadingArrayReducer } from '../../helpers/helpers'
import { createLoadingDataReducer } from '../../helpers/redux'
import { IAction } from '../apiMiddleware'
import * as actions from './actions'

export interface IAccessTokensState {
  loadingArray: string[]
  tokens: {
    isLoading: boolean
    isSaving: boolean
    isSaved: boolean
    data: IAccessToken[] | null
  }
  createdToken: IAccessTokenCreateResult | null
}

export default combineReducers({
  loadingArray: loadingArrayReducer(
    [actions.prefix],
    [
      actions.LIST_ACCESS_TOKENS_REQUEST,
      actions.CREATE_ACCESS_TOKEN_REQUEST,
      actions.UPDATE_ACCESS_TOKEN_REQUEST,
      actions.REVOKE_ACCESS_TOKEN_REQUEST,
    ],
  ),
  tokens: createLoadingDataReducer<IAccessToken[]>(
    [actions.LIST_ACCESS_TOKENS_REQUEST],
    [
      actions.CREATE_ACCESS_TOKEN_REQUEST,
      actions.UPDATE_ACCESS_TOKEN_REQUEST,
      actions.REVOKE_ACCESS_TOKEN_REQUEST,
    ],
  ),
  createdToken(state: IAccessTokenCreateResult | null = null, action: IAction) {
    switch (action.type) {
      // Cleared as a new create starts, so a failed request never shows an earlier plaintext.
      case actions.CREATE_ACCESS_TOKEN_REQUEST:
      case actions.REVOKE_ACCESS_TOKEN_SUCCESS:
      case actions.CLEAR_CREATED_ACCESS_TOKEN:
        return null
      case actions.CREATE_ACCESS_TOKEN_SUCCESS:
        return action.data as IAccessTokenCreateResult
      default:
        return state
    }
  },
})
